import React from 'react';

import { useCameras } from '../hooks/useCameras';

/**
 * Wrapper for useCameras hook so it can be more easily used
 * inside the map context but with `SharedPublicPage` from `App.tsx`.
 * Renders `null`.
 */
const CameraLayer: React.FC = () => {
  useCameras();
  return null;
};

export default CameraLayer;
